import { css } from "@emotion/react";
import styled from "@emotion/styled";
import {
  Container as FindOutMoreContainer,
  Message as FindOutMoreMessage,
} from "scmp-sdk/components/newsletter/newsletter-widget/find-out-more/styles";
import { StyledIconArrowPrevious } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/email-form/styles";
import { IconContainer as SocialButtonIconContainer } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/social-buttons/styles";
import {
  AgreementDescription as SignUpNewsletterAgreementDescription,
  Container as SignUpNewsletterContainer,
  SummaryContainer as SignUpNewsletterSummaryContainer,
  Title as SignUpNewsletterTitle,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/styles";
import {
  Container as SignUpSuccessMessageContainer,
  StyledFollowUsOnFacebook,
  StyledIconTickCircle,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-success-message/styles";
import type { ThemeType } from "scmp-sdk/components/newsletter/newsletter-widget/types";

import { theme as mediaTheme } from "shared/lib/styles";

export const theme: ThemeType = {
  findOutMore: {
    titleFontStyle: "small",
  },
  hasSummaryLine: false,
  newsletterIcon: {
    icon: "black",
  },
  orientation: "portrait",
  root: {
    containerSize: "custom",
    customCss: css`
      max-inline-size: 335px;
      ${mediaTheme.breakpoints.up("tablet")} {
        max-inline-size: 440px;
      }
    `,
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasDescription: true,
    summaryFontStyle: "medium",
    titleFontStyle: "large",
  },
  signUpSuccess: {
    checkEmailMessageStyle: "",
    hasCheckEmail: true,
    hasSeeMoreLinks: true,
    titleFontStyle: "medium",
  },
};

export const Container = styled.div`
  ${SignUpSuccessMessageContainer} {
    grid-template-areas:
      "Title Icon"
      "Footer Footer";
    grid-template-columns: 1fr min-content;

    color: #001246;
    text-align: start;
    ${mediaTheme.breakpoints.up("tablet")} {
      text-align: center;
    }

    ${StyledFollowUsOnFacebook} {
      margin-block-start: 12px;
    }

    ${StyledIconTickCircle} {
      path:first-child {
        fill: #eb4254;
      }

      path:last-child {
        fill: #ffffff;
      }
    }
  }

  ${FindOutMoreContainer} {
    text-align: center;
    ${FindOutMoreMessage} {
      color: #000000;
    }
  }

  ${SignUpNewsletterContainer} {
    color: #000000;
    text-align: center;

    ${StyledIconArrowPrevious} {
      path {
        stroke: #000000;
      }
    }

    ${SignUpNewsletterAgreementDescription} {
      color: #999999;
    }

    ${SignUpNewsletterSummaryContainer} {
      margin-block-end: 8px;
    }

    ${SignUpNewsletterTitle} {
      color: #001246;
      font-weight: 700;
      font-size: 20px;
      line-height: 23px;
    }

    ${SocialButtonIconContainer} {
      background-color: #ffffff;
    }
  }
`;
